import * as React from "react";

interface GenPanelHeaderProps {
  children: React.ReactNode;
  rightContent: React.ReactNode;
}

export default function GenPanelHeader(
  {
    children,
    rightContent,
  }: GenPanelHeaderProps,
) {
  return (
    <div className="gen-panel-header">
      <div className="gen-panel-header-title">
        <h1>{children}</h1>
      </div>
      <div className="gen-panel-header-right-content">
        {rightContent}
      </div>
    </div>
  );
}
